import { InvestingType } from "./kyc.data.models";

export interface UserPhone {
    phoneNumber?: string | undefined;
    userId?: string | undefined;
    nationalId?: string | undefined;
}
export enum GrpcLanguage {
    Ar = "Ar",
    En = "En",
}
export enum ERiskLevel
{
    Low = 'Low',
    Medium = 'Medium',
    MediumToHigh = 'MediumToHigh',
    High = 'High'
}
export interface LoginInvestorInputDto {
    phoneNumber: string;
    password: string;
    deviceType: MobileDeviceType;
    fcmToken: string | undefined;
    deviceId: string | undefined;
    otp: string;
}
export interface ValidateCredantialsDto {
    nationalId: string;
    password: string;
}

export enum MobileDeviceType {
    Android = "Android",
    IOS = "IOS",
}

export interface UserPassword {
    password?: string | undefined;
    confirmPassword?: string | undefined;
    phoneNumber?: string | undefined;
    otp?: string | undefined;
}

export interface UserRegisterInput {
    phoneNumber?: string | undefined;
    email?: string | undefined;
    nationalID?: string | undefined;
    birthDate?: string | undefined;
    language?: GrpcLanguage;
    investTypeId?: string;
    dateType: 'hijri' | 'gregorian';
}

export interface RefreshTokenInputDto {
    phoneNumber?: string | undefined;
    refreshToken?: string | undefined;
}

export interface UserOTP {
    otp?: string | undefined;
    phoneNumber?: string | undefined;
    language?: GrpcLanguage;
}
export interface LoginResultDto {
    "currentUsedInvestorAccountId": string,
    "email": string,
    "phoneNumber": string,
    "nationalId": string,
    "userTypeId": string,
    "investTypeId": InvestingType,
    "userId": string,
    "token": string,
    "arabicName": string,
    "englishName": string,
    "isActivated": boolean,
    "isSuspended": boolean,
    "isIdExpired": boolean,
    "birthDate": Date,
    "gender": string,
    isCompleteProfile: boolean,
    userKYCStatus: string,
    "refreshToken": string,
    "expiryTokenInMinutes": number,
    "moznUserStatus": string,
    "investorDegreeType": string,
    "hasProfessionalPendingRequest": boolean,
    "hasInstitutionalPendingRequest": boolean,
    "expiryTokenDate": Date,
    "parentUserId": string,
    "currentActiveAccountId": string,
    kycRiskLevel: ERiskLevel
}